import React from "react";
import FormatService from "../../services/format-service";

export default function BuildingStatShareWidget({ shares=null,
                                                  widgetClass=null,
                                                  containerClass=null,
                                                  ...props})
{

  return (
    <>
      {shares?.allShares && shares?.allShares>0 && <div className={containerClass}>
        <div className={widgetClass}>
          <h5>Podiel</h5>
          <h3 className="mb-1 mt-0">{FormatService.formatNumber((shares.groupShares/shares.allShares)*100)} %</h3>
          <div>Družstvo: 100%</div>
          <div>Bezpodielové: 0%</div>
        </div>
      </div>}
    </>
  );
}
